import { environment } from "@env/environment";

export class Api {
  public getHostV1(): string {
    return `${environment.apiHost}/api/v1`;
  }

  public getGraphQL(): string {
    return `${environment.graphQL}`;
  }
}
